import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, RespState} from '@/types/store/states'
import {RawResp} from 'src/types/entity/RawResp'
import Resp from 'src/models/resp/Resp'
import {API, RESP_STATUS_BLANK} from '@/constants'


const store: Module<RespState, RootState> = {
  namespaced: true,
  state: {
    resps: {}
  },
  getters: {
    getResp: state => (data: RawResp) => {
      if (state.resps[data.id]) {
        state.resps[data.id].setData(data)
      } else {
        Vue.set(state.resps, data.id, new Resp(data))
      }
      return state.resps[data.id]
    },
    getResps: (state, getters) => (data: RawResp[], returnArray: boolean = true) => {
      const result = returnArray ? [] : {};
      for (const item of data) {
        const itemModel = getters.getResp(item);
        (result as Resp[]).push(itemModel);
      }
      return result;
    },
    blankRespNum: (state, getters) => {
      let num = 0;
      for (const resp in state.resps) {
        if (state.resps[resp].getStatus() === RESP_STATUS_BLANK) num++;
      }
      return num;
    }
  },
  mutations: {
  },
  actions: {
    async key (context, key) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.respKey,
        data: {resp_key: key},
        flag: 'silent'
      }, {root: true})
      return response;
    },
    async get (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.respGet,
        data: {resp_id: id},
        flag: 'silent'
      }, {root: true})
      return context.getters.getResp(response);
    },
    async find (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.respFind,
        data,
        flag: 'silent'
      }, {root: true})
      return {resps: context.getters.getResps(response.resps), count: response.total || 0};
    },
    async ans (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.respAns,
        data,
      }, {root: true})
      return response;
    },
  }
}

export default store